import { NavItemSchema } from '@shared/interfaces/nav/nav-item-schema';


export const chargeinformationNavItems: NavItemSchema[] = [
  {
    title: 'chargeInformation.navItems.overview',
    routeTemplate: ['/chargeinformation', '{id}']
  },
  {
    title: 'chargeInformation.navItems.prices',
    routeTemplate: ['/chargeinformation', '{id}', 'prices']
  },
  {
    title: 'chargeInformation.navItems.setupPrices',
    routeTemplate: ['/chargeinformation', '{id}', 'setupprices']
  },
  {
    title: 'chargeInformation.navItems.businessTransactions',
    routeTemplate: ['/chargeinformation', '{id}', 'businesstransactions']
  },
];
